// Shared shadow scale for the theme-builder feature (two tiers only).
// SHADOW_CARD: resting surface. SHADOW_POPOVER: elevated/interactive surface.
export const SHADOW_CARD = '0 1px 2px rgba(0,0,0,0.07), 0 1px 3px rgba(0,0,0,0.04)';
export const SHADOW_POPOVER = '0 4px 20px rgba(0,0,0,0.14), 0 1px 5px rgba(0,0,0,0.10)';
